const ErrorCodes = {
  "UI-E-001": {
    code: "UI-E-001",
    title: "Something went wrong",
    message:
      "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "SERVER-E-001": {
    code: "SERVER-E-001",
    title: "Server error",
    message:
      "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "AUTH-E-001": {
    code: "AUTH-E-001",
    title: "Authentication Failed",
    message: "Authentication failed due to invalid credentials.",
    description:
      "The credentials provided are invalid. Please check your username and password and try again.",
  },
  "AUTH-E-002": {
    code: "AUTH-E-002",
    title: "Session Expired",
    message: "Session has expired. Please log in again.",
    description:
      "Your active session may have expired or we may be having difficulties finding your session information.",
  },
  "AUTH-E-003": {
    code: "AUTH-E-003",
    title: "Access Denied",
    message:
      "Access denied. You do not have permission to access this resource.",
    description:
      "You do not have permission to access this resource. Please contact your administrator for assistance.",
  },
  "AUTH-E-004": {
    code: "AUTH-E-004",
    title: "Resource Not Found",
    message: "Resource not found. Please check the URL and try again.",
    description:
      "The resource you are trying to access could not be found. Please check the URL and try again.",
  },
  "AUTH-E-005": {
    code: "AUTH-E-005",
    title: "Internal Server Error",
    message: "Internal server error. Please try again later.",
    description: "An internal server error occurred. Please try again later.",
  },
  "REQ-E-0001": {
    code: "API-E-0001",
    title: "INVALID_REQUEST",
    message: "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "REQ-E-0002": {
    code: "API-E-0002",
    title: "VALIDATION_FAILED",
    message: "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "REQ-E-0003": {
    code: "API-E-0003",
    title: "DUPLICATE_RESOURCE",
    message: "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "REQ-E-0004": {
    code: "API-E-0004",
    title: "MISSING_REQUIRED_FIELD",
    message: "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "REQ-E-0005": {
    code: "API-E-0005",
    title: "Bad request",
    message:
      "We’re having trouble loading the requested data. Please try again shortly.",
  },
  "M-E-0001": {
    code: "MKT-E-0001",
    title: "INACCESSIBLE_MARKET",
    message: "This market is not applicable for this module.",
  },
  "V-E-0001": {
    code: "V-E-0001",
    title: "Invalid View Input",
    message: "View input is invalid. Please check all fields and try again.",
  },
  "V-E-0002": {
    code: "V-E-0002",
    title: "View Name Required",
    message: "View name cannot be empty. Please enter a name.",
  },
  "V-E-0003": {
    code: "V-E-0003",
    title: "Incomplete View Details",
    message: "View details are incomplete. Please fill in all required fields.",
  },
  "V-E-0004": {
    code: "V-E-0004",
    title: "Invalid Module",
    message: "Invalid module selected.",
  },
  "V-E-0005": {
    code: "V-E-0005",
    title: "Invalid Screen Type",
    message: "Invalid screen type.",
  },
  "V-E-0006": {
    code: "V-E-0006",
    title: "View Mode Required",
    message: "View mode is required. Please select a view mode.",
  },
  "V-E-0007": {
    code: "V-E-0007",
    title: "Invalid Visualization Type",
    message: "Invalid visualization type.",
  },
  "V-E-0008": {
    code: "V-E-0008",
    title: "Invalid View Mode & Interval Type",
    message: "Interval Type must be empty for Point in Time or Pre/Post view modes.",
  },
  "V-E-0009": {
    code: "V-E-0009",
    title: "Invalid Stat Testing Selection",
    message: "POP, PTP, and YOY stat testing are unavailable for Trends Moving Average. PTP is unavailable for Periodic Trends.",
  }
};

export default ErrorCodes;
